import { render } from "./StyleGuide.vue?vue&type=template&id=c6d72ff6&scoped=true&ts=true"
import script from "./StyleGuide.vue?vue&type=script&lang=ts"
export * from "./StyleGuide.vue?vue&type=script&lang=ts"

import "./StyleGuide.vue?vue&type=style&index=0&id=c6d72ff6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6d72ff6"],['__file',"src/views/StyleGuide.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6d72ff6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6d72ff6', __exports__)) {
    api.reload('c6d72ff6', __exports__)
  }
  
  module.hot.accept("./StyleGuide.vue?vue&type=template&id=c6d72ff6&scoped=true&ts=true", () => {
    api.rerender('c6d72ff6', render)
  })

}


export default __exports__